import React from 'react';
import { GameMode } from '../../types';
import './Game.css';

interface ScorePanelProps {
  gameMode: GameMode;
  currentScore: number;
  elapsedTime: number;
}

const ScorePanel: React.FC<ScorePanelProps> = ({ currentScore, elapsedTime }) => {
  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="score-panel" role="region" aria-label="Current game statistics">
      <div className="panel-section">
        <h2 className="panel-title">Session Stats</h2>
        <div className="session-stats">
          <div className="stat-box">
            <div className="stat-label">Score</div>
            <div className="stat-value large">{currentScore}</div>
          </div>
          <div className="stat-box">
            <div className="stat-label">Time</div>
            <div className="stat-value large">{formatTime(elapsedTime)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScorePanel;
